import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  UserGroupIcon, 
  BookOpenIcon,
  ExclamationTriangleIcon
} from '@heroicons/react/24/outline';
import { useAuthStore } from '../../stores/authStore';

const TrainerDashboard: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();

  const quickActions = [
    { 
      name: 'My Clients', 
      icon: UserGroupIcon, 
      color: 'bg-blue-600', 
      action: () => navigate('/trainer/clients'),
      description: 'Manage workouts, meals & progress'
    },
    { 
      name: 'Libraries', 
      icon: BookOpenIcon, 
      color: 'bg-green-600', 
      action: () => navigate('/libraries'),
      description: 'Browse exercises, equipment & food'
    },
  ];

  // Authorization check
  if (!user?.roles?.includes('TRAINER')) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <ExclamationTriangleIcon className="mx-auto h-12 w-12 text-gray-400" />
          <h3 className="mt-2 text-sm font-medium text-gray-900">Access Denied</h3>
          <p className="mt-1 text-sm text-gray-500">You need trainer privileges to access this dashboard.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 -mt-6">
      {/* Mobile Header */}
      <div className="sticky top-16 z-20 bg-white border-b border-gray-200 px-4 py-4">
        <h1 className="text-xl font-bold text-gray-900">
          Trainer Dashboard
        </h1>
      </div>

      {/* Quick Actions */}
      <div className="px-4 py-6">
        <div className="grid grid-cols-1 gap-4 max-w-md mx-auto">
          {quickActions.map((action) => (
            <button
              key={action.name}
              onClick={action.action}
              className={`${action.color} text-white p-6 rounded-lg active:opacity-75 transition-opacity text-center`}
            >
              <action.icon className="h-8 w-8 mx-auto mb-3" />
              <div className="text-lg font-medium">{action.name}</div>
              <div className="text-sm opacity-90 mt-2">{action.description}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrainerDashboard;
